import './cartDrawer.scss';

import { useSelector } from 'react-redux';
import { Drawer } from '@eliberty/design-system-react/mantine';

import { findModalPortal } from '~helpers';
import { useDeferredOpen } from '~hooks';
import { CartTitle } from '~molecules';
import { CartView } from '~organisms';
import { selectCartParticipantCount } from '~redux/reducers/cartSlice';
import type { Simulation } from '~types/appsync.types';
import type { CartProduct } from '~types/cart';

export interface CartDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  onCheckout?: (products: CartProduct[], simulation: Simulation | undefined) => void;
  onExitTransitionEnd?: () => void;
}

const CartDrawer = ({ isOpen, onCheckout, onClose, onExitTransitionEnd }: CartDrawerProps) => {
  const deferredOpen = useDeferredOpen(isOpen);
  const participantCount = useSelector(selectCartParticipantCount);

  return (
    <Drawer
      opened={deferredOpen}
      onClose={onClose}
      position='right'
      size='lg'
      withCloseButton
      closeOnClickOutside
      closeOnEscape
      withOverlay
      portalProps={{ target: findModalPortal() }}
      onExitTransitionEnd={onExitTransitionEnd}
      classNames={{
        body: 'CartDrawer_drawerBody',
        content: 'CartDrawer_content',
        header: 'CartDrawer_header',
        title: 'CartDrawer_headerContent',
      }}
      title={
        <span className='CartDrawer_title'>
          <CartTitle countClassName='CartDrawer_titleCount' participantCount={participantCount} />
        </span>
      }
      data-testid='cart-drawer'
    >
      <Drawer.Body>
        <CartView onCheckout={onCheckout ?? (() => {})} />
      </Drawer.Body>
    </Drawer>
  );
};

export default CartDrawer;
